<template>
   <div>
     <div class="search_unit">
      <div style='display:inline-block;'>
       <el-input placeholder="标题" v-model="keywords" class="input-with-select" @change='getList()'>
        <el-select v-model="type" slot="prepend" placeholder="筛选条件" @change="getList()">
            <el-option v-for="item in typelist" :key="item.val" :label="item.name"  :value="item.val"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
       </el-input>
      </div> 
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="缩略图">
      <template slot-scope="scope"> 
           <el-image
          style="width: 100px; height: 100px"
          :src="scope.row.headimg"
          fit="fit"></el-image>
      </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        >
      </el-table-column>
      <el-table-column
        prop="typename"
        label="首页位置">
      </el-table-column>
      <el-table-column
        prop="linktypename"
        label="跳转类型">
      </el-table-column>
      <el-table-column
        prop="linkname"
        label="跳转目标">
      </el-table-column>
      <el-table-column
        prop="position"
        label="位置号">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
             <el-dropdown split-button type="primary" @click='handleEdit(scope.row.id)' @command='(command)=>handleItem(command,scope.row.id)'>
              编辑
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='delete'>删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        keywords:'',
        type:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        },
        typelist:[]
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/index/getIndexList",{pageinfo:this.pageinfo,keywords:this.keywords,type:this.type}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.contentlist
                  this.typelist=data.result.info.typelist
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      handleEdit(contentid){
          this.$router.push({name:'addindex',query:{contentid:contentid}})
      },
      handleItem(command,id){
        switch(command){
          case 'delete':
                this.$post("/index/delIndex",{id:id}).then((data)=>{
                  if(data.result.success){
                      this.$message({message:data.result.info,type:'success'})
                      setTimeout(()=>{this.getList()},300)
                  }else{
                      this.$message.error(data.result.info)
                  } 
                })
                break;
          default:
                this.$message.error("选项有误");      
        }
      }
  }
}
</script>

<style scoped lang="scss">
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
</style>
